import { toLower, trim } from "lodash";
import { Address } from "src/app/backend/models/address";

export function formatAddress(address: Address | undefined): string {
  if (!address) {
    return "";
  }

  return `${address.address || ""}, ${address.city || ""} ${
    address.zipCode || ""
  } ${address.state ? `(${address.state})` : ""} ${address.country || ""}`;
}

export function addressIsSame(leftAddress: Address, right: Address): boolean {
  return (
    toLower(trim(leftAddress.address || "")) ===
      toLower(trim(right.address || "")) &&
    toLower(trim(leftAddress.city || "")) === toLower(trim(right.city || "")) &&
    toLower(trim(leftAddress.zipCode || "")) ===
      toLower(trim(right.zipCode || "")) &&
    toLower(trim(leftAddress.state || "")) ===
      toLower(trim(right.state || "")) &&
    toLower(trim(leftAddress.country || "")) ===
      toLower(trim(right.country || ""))
  );
}
